import * as constants from './constants';
import * as routePath from './routePath';
import enums from './enums';

export function convertToBps(bandwidth) {
  return (
    bandwidth.value *
    constants.BANDWIDTH_BPS_CONVERSION_VALUES[
      constants.BANDWIDTH_UNITS.indexOf(bandwidth.unit)
    ]
  );
}

export function convertBandwidthInUnits(bandwidthInBps) {
  let bandwidth = {};

  if (bandwidthInBps < constants.BANDWIDTH_BPS_CONVERSION_VALUES[1]) {
    bandwidth.value = parseFloat(
      (bandwidthInBps / constants.BANDWIDTH_BPS_CONVERSION_VALUES[0]).toFixed(
        2,
      ),
    );
    bandwidth.unit = constants.BANDWIDTH_UNITS[0];
  } else if (bandwidthInBps < constants.BANDWIDTH_BPS_CONVERSION_VALUES[2]) {
    bandwidth.value = parseFloat(
      (bandwidthInBps / constants.BANDWIDTH_BPS_CONVERSION_VALUES[1]).toFixed(
        2,
      ),
    );
    bandwidth.unit = constants.BANDWIDTH_UNITS[1];
  } else if (bandwidthInBps < constants.BANDWIDTH_BPS_CONVERSION_VALUES[3]) {
    bandwidth.value = parseFloat(
      (bandwidthInBps / constants.BANDWIDTH_BPS_CONVERSION_VALUES[2]).toFixed(
        2,
      ),
    );
    bandwidth.unit = constants.BANDWIDTH_UNITS[2];
  } else {
    bandwidth.value = parseFloat(
      (bandwidthInBps / constants.BANDWIDTH_BPS_CONVERSION_VALUES[3]).toFixed(
        2,
      ),
    );
    bandwidth.unit = constants.BANDWIDTH_UNITS[3];
  }

  return bandwidth;
}

export function getCurrentPath() {
  return window.location.pathname;
}

export function getPathToRedirect(registrationStatus) {
  switch (registrationStatus) {
    case enums.RegistrationSteps.SUCCESS: {
      return routePath.registerSuccessRoute;
    }
    case enums.RegistrationSteps.APPROVED: {
      return routePath.registerApprovedRoute;
    }
    case enums.RegistrationSteps.PENDING: {
      return routePath.registerPendingRoute;
    }
    default:
      return '';
  }
}
